import Vue from 'vue'
import App from './soMeLoginButtons.vue'

// import webmessage from '../../globalComponents/webmessage.vue'
// Vue.component('webmessage', webmessage);
// Vue.config.ignoredElements = ['wsm']

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  name: "Social-Login-Buttons",
  data() {
    return {
      isCheckOutPage: window.isCheckOutPage,
    }
  }
}).$mount('#social-login-buttons')

